<!--肝脏增强CT-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import BGWJ from "@/components/BGWJ.vue"

import {useCommonStore} from "@/stores/common.js"
import { useUserStore } from "@/stores/user";
// 拿到医生信息
const user = useUserStore()
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null,
  jhw:false
});
let centerDialogVisible = ref(false)
// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
const ischeck = computed(() => {
    return model.fields
})

let width = ref(null)
const watchWindowSize = ()=>{

// 获取窗口的宽度和高度，不包括滚动条
var w = document.documentElement.clientWidth;
var h = document.documentElement.clientHeight;
// 打印结果
// result.innerHTML = "宽: " + w + ", " + "高: " + h
// console.log(w,'wwwwwwwwwww')
if (w > 1000) {
  // 弹窗的宽度设置80% 否则100%
  width.value = 40
}else{
  width.value = 90
}
}
watchWindowSize()

;
window.onresize = ()=>{
  watchWindowSize()

};


</script>
<template>
  <template v-if="crfFields">
    <!-- <div style="display:flex;"> -->
      <h2 v-if="!props.jhw">病理报告</h2>
      <h2 v-else>V0以外的肝脏病理</h2>
  
    <el-form-item label="是否完成病理报告上传"  v-if="crfFields && notScreen" class="redStar">
        <el-checkbox-group v-model="crfFields['是否完成病理报告上传']" style="margin-left: 10px;">
                  <el-checkbox label="已完成"></el-checkbox>
              </el-checkbox-group>
    </el-form-item>
    <template v-if="crfFields['是否完成病理报告上传']?.length > 0  || !notScreen">
     
      <div class="redStar up_redstar" >
        <upload :type="props.type" :data="model" name="blbgsmwj" btn_name="扫描文件上传"></upload>
      </div>
      <p class="tishi">扫码文件上传时，各单位请至少上传一个相应的应用软件以便打开扫描文件</p>
      <p>1、没有扫描条件的单位可将病理片寄华山医院（<span class="span" @click="centerDialogVisible = !centerDialogVisible">查看寄送方式</span>）</p>
      <p>2、各单位每病人切一张白片寄华山医院（<span class="span" @click="centerDialogVisible = !centerDialogVisible">查看寄送方式</span>）</p>
    
      <BGWJ :type="props.type" :data="model" name="病理报告" btn_name="病理报告照片上传-blbg"></BGWJ>
    </template>
     <!--<el-form-item label="肝脏病理" :prop="itemProp('肝脏病理')">
      <el-input v-model="crfFields['肝脏病理']" type="textarea"
                placeholder="请输入肝脏病理"></el-input>
    </el-form-item> -->
    <!-- 寄送地址 -->
    <el-dialog v-model="centerDialogVisible" title="寄送方式" :width="`${width}%`" center>
      <div class="dialogtxt">
        <p>病理片或白片寄送华山医院流程：设置2个选项可同时多选：</p>  
        <p>（1）病理染色片寄送：选取HE染色及MASSON染色病理片至少各1张。 </p>
        <p>（2）病理切白片10张寄送：白片需一月内切片且切片后4℃妥善保存的。</p>
        <p>寄送地址：上海市乌鲁木齐中路12号5号楼510室，王瑾瑜收，15618985659 。</p>
        <p>注意事项：玻璃片需包装妥当（外包缓冲气泡膜）再行寄送，寄送前请联系王瑾瑜15618985659并发送单号，推荐使用顺丰快递。</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>

  </template>
</template>

<style lang="scss" scoped>
.up_redstar{
  display: flex;
  ::v-deep .btn_fiexd{
    margin-top: 12px;
  }
 
}
.tishi{
  font-size: 14px;
  color: red;
}
.span{
    text-decoration: underline;
    cursor: pointer;
  }
  .dialogtxt{
    font-size: 16px;
  }
</style>